"use client";

import React, { useEffect } from "react";
import { initAppInsights } from "./telemetry";

export default function AppInsightsProvider({ children }: { children: React.ReactNode }) {
    useEffect(() => {
        initAppInsights();
    }, []);

    return <>{children}</>;
}
